<style>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .m-form__group:first-child {
        padding-top: 15px;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row m-portlet__body">
            <div class="col-lg-6">
                <h4>Megrendelői adatok</h4>
                <div class="form-group" v-bind:class="{'has-danger': hasError('email')}">
                    <label for="email">Email cím</label>
                    <input type="email" class="form-control" id="email" aria-describedby="emailHelp" v-model="model.email">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('email')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{'has-danger': hasError('phone')}">
                    <label for="tel">Telefonszám</label>
                    <input type="text" class="form-control" id="tel" aria-describedby="emailHelp" v-model="model.phone">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('phone')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <div class="form-group" v-bind:class="{'has-danger': hasError('billing_company')}">
                    <label for="tel">Cégnév</label>
                    <input type="text" class="form-control" id="billing_company" aria-describedby="emailHelp" v-model="model.billing_company">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_company')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <div class="form-group" v-bind:class="{'has-danger': hasError('tax_number')}">
                    <label for="tel">Adószám</label>
                    <input type="text" class="form-control" id="tax_number" aria-describedby="emailHelp" v-model="model.tax_number">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('tax_number')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <h4>Számlázási adatok</h4>

                <div class="form-group" v-bind:class="{'has-danger': hasError('billing_name')}">
                    <label for="name">Név</label>
                    <input type="text" class="form-control" id="name" aria-describedby="emailHelp" v-model="model.billing_name">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_name')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{'has-danger': hasError('billing_country')}">
                    <label for="bill_address">Ország</label>
                    <input type="text" class="form-control" id="bill_address" aria-describedby="emailHelp" v-model="model.billing_country">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_country')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="form-group" v-bind:class="{'has-danger': hasError('billing_zip')}">
                            <label for="bill_zip">Irányítószám</label>
                            <input type="text" class="form-control" id="bill_zip" aria-describedby="emailHelp" v-model="model.billing_zip">
                            <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_zip')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="form-group" v-bind:class="{'has-danger': hasError('billing_city')}">
                            <label for="bill_city">Város</label>
                            <input type="text" class="form-control" id="bill_city" aria-describedby="emailHelp" v-model="model.billing_city">
                            <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_city')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-8">
                        <div class="form-group" v-bind:class="{'has-danger': hasError('billing_street')}">
                            <label for="bill_zip">Utca</label>
                            <input type="text" class="form-control" id="billing_street" aria-describedby="emailHelp" v-model="model.billing_street">
                            <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_street')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group" v-bind:class="{'has-danger': hasError('billing_number')}">
                            <label for="bill_city">Utca</label>
                            <input type="text" class="form-control" id="billing_number" aria-describedby="emailHelp" v-model="model.billing_number">
                            <div class="form-control-feedback">
                                    <span v-for="message in filter('billing_number')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="szallitasi-adatok">
                    <h4>Szállítási adatok</h4>

                    <div class="form-group" v-bind:class="{'has-danger': hasError('shipping_name')}">
                        <label for="name">Név</label>
                        <input type="text" class="form-control" id="sh_name" aria-describedby="emailHelp" v-model="model.shipping_name">
                        <div class="form-control-feedback">
                                    <span v-for="message in filter('shipping_name')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                        </div>
                    </div>

                    <div class="form-group" v-bind:class="{'has-danger': hasError('shipping_country')}">
                        <label for="ship_address">Ország</label>
                        <input type="text" class="form-control" id="shipping_country" aria-describedby="emailHelp" v-model="model.shipping_country">
                        <div class="form-control-feedback">
                                    <span v-for="message in filter('shipping_country')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group" v-bind:class="{'has-danger': hasError('shipping_zip')}">
                                <label for="ship_zip">Irányítószám</label>
                                <input type="text" class="form-control" id="ship_zip" aria-describedby="emailHelp" v-model="model.shipping_zip">
                                <div class="form-control-feedback">
                                    <span v-for="message in filter('shipping_zip')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8">
                            <div class="form-group" v-bind:class="{'has-danger': hasError('shipping_city')}">
                                <label for="ship_city">Város</label>
                                <input type="text" class="form-control" id="ship_city" aria-describedby="emailHelp" v-model="model.shipping_city">
                                <div class="form-control-feedback">
                                    <span v-for="message in filter('shipping_city')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-8">
                            <div class="form-group" v-bind:class="{'has-danger': hasError('shipping_street')}">
                                <label for="ship_zip">Utca</label>
                                <input type="text" class="form-control" id="shipping_street" aria-describedby="emailHelp" v-model="model.shipping_street">
                                <div class="form-control-feedback">
                                    <span v-for="message in filter('shipping_street')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group" v-bind:class="{'has-danger': hasError('shipping_number')}">
                                <label for="ship_city">Utca</label>
                                <input type="text" class="form-control" id="shipping_number" aria-describedby="emailHelp" v-model="model.shipping_number">
                                <div class="form-control-feedback">
                                    <span v-for="message in filter('shipping_number')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">

                <div class="form-group" v-bind:class="{'has-danger': hasError('shipment_method_id')}">
                    <label for="exampleFormControlSelect1">Szállítási mód</label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="model.shipment_method_id" v-if="model.selectables && model.selectables.shipments">
                        <option v-for="item in model.selectables.shipments" v-bind:key="item.id" :value="item.id">{{item.name}}</option>
                    </select>
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('shipment_method_id')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <div class="form-group" v-bind:class="{'has-danger': hasError('foxpost_id')}">
                    <label for="exampleFormControlSelect1">Foxpost</label>
                    <select class="form-control" id="exampleFormControlSelect12" v-model="model.foxpost_id" v-if="model.selectables && model.selectables.foxpost">
                        <option :value="null">-</option>
                        <option v-for="item in model.selectables.foxpost" v-bind:key="item.id" :value="item.id">{{item.name}} / {{item.city}} {{item.address}}</option>
                    </select>
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('foxpost_id')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <div class="form-group" v-bind:class="{'has-danger': hasError('payment_method_id')}">
                    <label for="exampleFormControlSelect1">Fizetési mód</label>
                    <select class="form-control" id="exampleFormControlSelect2" v-model="model.payment_method_id">
                        <option :value="1">Barion fizetés</option>
                    </select>
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('payment_method_id')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <table class="table sum">
                    <thead>
                    <tr>
                        <th scope="col">Tétel</th>
                        <th scope="col">Db</th>
                        <th scope="col">Részösszeg</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="model && model.items" v-for="(item, index) in model.items" v-bind:key="`items-`+index">
                        <td>{{item.book.author}} - {{item.book.title}} ({{item.book.isbn}})</td>
                        <td>{{item.quantity}} db</td>
                        <td class="text-right">{{item.gross_value}} Ft</td>
                    </tr>
                    <tr>
                        <td>{{shipmentName}}</td>
                        <td>1 db</td>
                        <td class="text-right">{{shipmentPrice}} Ft</td>
                    </tr>
                    <tr>
                        <td>Összesen</td>
                        <td class="text-right" colspan="2">{{model.gross_value }} Ft
                            <br/>
                            <small id="sum" class="form-text text-muted">Az ár az ÁFÁ-t tartalmazza.</small>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="form-group" v-bind:class="{'has-danger': hasError('order_status')}">
                    <label for="exampleFormControlSelect1">Megrendelés státusz</label>
                    <select class="form-control" id="exampleFormControlSelect3" v-model="model.order_status">
                        <option :value="0">Megrendelve</option>
                        <option :value="1">Fizetve</option>
                        <option :value="2">Teljesítve</option>
                        <option :value="3">Sztornózva</option>
                    </select>
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('order_status')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

                <div class="form-group" v-bind:class="{'has-danger': hasError('barion_id')}">
                    <label for="barion_id">Barion azonosító</label>
                    <input type="text" class="form-control" id="barion_id" aria-describedby="emailHelp" v-model="model.barion_id">
                    <div class="form-control-feedback">
                                    <span v-for="message in filter('barion_id')" v-bind:key="message">
                                        {{message}} <br/>
                                    </span>
                    </div>
                </div>

            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/orders/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
export default {
  name: 'OrderForm',
  components: {Buttons},
  props: {
    model: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    url: {
      require: true
    }
  },
  watch: {
    model: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
      },
      deep: true
    }
  },
  computed: {
    shipmentName: function () {
      if (this.model.selectables && this.model.selectables.shipments) {
        for (let it in this.model.selectables.shipments) {
          if (this.model.selectables.shipments[it].id === this.model.shipment_method_id) {
            return this.model.selectables.shipments[it].name
          }
        }
      }
    },
    shipmentPrice: function () {
      if (this.model.selectables && this.model.selectables.shipments) {
        for (let it in this.model.selectables.shipments) {
          if (this.model.selectables.shipments[it].id === this.model.shipment_method_id) {
            return this.model.selectables.shipments[it].price
          }
        }
      }
    }
  },
  methods: {
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    save () {
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/order/OrderForm.vue